import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { calculateWordsFromString, convertTo12HourFormat, dateConvert, timeStringToDate } from "../../../utils/Helper";

export const useGatePassRequest = ({ filterOptions, editUser, onClose, userShiftTime }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [fieldValues, setFieldValues] = useState({ user: {}, leave_type: {}, approver: {}, reason: "", out_time: null, in_time: null })
    const [btnLoader, setBtnLoader] = useState(false);
    const [isRequestOpen, setIsRequestOpen] = useState(false);
    const [shiftEndDate, setShiftEndDate] = useState(null);

    useEffect(() => {
        if (userShiftTime && userShiftTime.shift_end_time) {
            setShiftEndDate(userShiftTime.shift_end_time);
        }
    }, [userShiftTime]);

    useEffect(() => {
        !_.isEmpty(editUser) && handleEdit();
    }, [editUser])

    useEffect(() => {
        const leaveTypeName = fieldValues?.leave_type?.leave_type_name;
        setIsRequestOpen(
            leaveTypeName && !['leaveapplied', 'office work'].includes(leaveTypeName.toLowerCase())
        );
    }, [fieldValues?.leave_type?.leave_type_name]);


    const handleLeaveRequest = async () => {
        if (_.isEmpty(fieldValues?.user)) {
            showInfo("Info", "Please select a user");
            return;
        } else if (_.isEmpty(fieldValues?.leave_type)) {
            showInfo("Info", "Please select leave type");
            return;
        } else if (!fieldValues?.out_time) {
            showInfo("Info", "Please select out time");
            return;
        } else if (_.isEmpty(fieldValues?.approver)) {
            showInfo("Info", "Please select approver");
            return;
        } else if (calculateWordsFromString(fieldValues?.reason) < 5) {
            showInfo("Info", "Reason should contain minimum 5 words");
            return;
        }
        const outTime = new Date(fieldValues.out_time);
        const inTime = new Date(fieldValues.in_time);
        if (outTime < new Date() && _.isEmpty(editUser)) {
            showInfo("Info", "Out Time can't be less than current time");
            return;
        } else if (inTime > timeStringToDate(shiftEndDate, new Date())) {
            showInfo("Info", `In time cannot be greater than ${convertTo12HourFormat(shiftEndDate)} (shift end)`);
            return;
        }
        if (fieldValues?.out_time && fieldValues?.in_time && isRequestOpen) {
            const diffHours = (inTime.getTime() - outTime.getTime()) / (1000 * 60 * 60);
            if (parseFloat(diffHours)?.toFixed(2) > 1) {
                showInfo("Info", "You are not allowed to apply gate pass for more than 1 hours");
                return;
            } else if (parseFloat(diffHours)?.toFixed(2) < 0) {
                showInfo("Info", "In time can't be less than out time.");
                return;
            }
        } else if (fieldValues?.out_time && isRequestOpen) {
            if (shiftEndDate) {
                const shiftEnd = timeStringToDate(shiftEndDate);
                const diffHours = (shiftEnd.getTime() - outTime.getTime()) / (1000 * 60 * 60);
                if (parseFloat(diffHours)?.toFixed(2) > 1) {
                    showInfo("Info", "You are not allowed to apply gate pass for more than 1 hours");
                    return;
                }
            }
        }
        setBtnLoader(true);
        try {
            const payload = {
                "gate_pass_id": editUser?.gate_pass_id || 0,
                "requested_user_code": fieldValues?.user?.user_code,
                "leave_type_id": fieldValues?.leave_type?.leave_type_id,
                "leave_reason": fieldValues?.reason,
                "requested_to": fieldValues?.approver?.user_code,
                "is_gatepass_in_time": false,
                "is_gatepass_out_time": false,
                "user_in_datetime": fieldValues?.in_time ? dateConvert(inTime, "iso-string") : null || null,
                "user_out_datetime": fieldValues?.out_time ? dateConvert(outTime, "iso-string") : "" || "",
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTGATEPASSREQUEST"), payload);
            if (res.body.data) {
                setBtnLoader(false)
                showSuccess('Success', res.body.message)
                handleClearRequest();
                onClose();
            }
        } catch (error) {
            setBtnLoader(false)
            console.error(error, "Error");
            showError("Error", error?.response?.data?.errorMessage);

        }
    }


    const handleEdit = () => {
        const user = _.findWhere(filterOptions?.user, { user_code: editUser?.user_code })
        const approved = _.findWhere(filterOptions?.approved_by, { user_display_name: editUser?.requested_to })
        setFieldValues((prev) => ({ ...prev, user: user, reason: editUser?.leave_reason, leave_type: { leave_type_id: editUser?.leave_type_id, leave_type_name: editUser?.leave_type_name }, approver: approved, out_time: editUser?.user_out_datetime ? new Date(editUser?.user_out_datetime) : "", in_time: editUser?.user_in_datetime ? new Date(editUser?.user_in_datetime) : "" }));
    }

    const handleClearRequest = async () => {
        setFieldValues({ user: {}, leave_type: {}, approver: {}, reason: "", out_time: null, in_time: null });
    }

    const handleUser = (e) => {
        const currentUserReporter = _.findWhere(filterOptions?.approved_by, { employee_id: e?.reporting_employee_id })
        if (!_.isEmpty(currentUserReporter)) {
            setFieldValues((prev) => ({ ...prev, approver: currentUserReporter, user: e }));
        } else {
            setFieldValues((prev) => ({ ...prev, approver: {}, user: e }));
        }
    }

    return useMemo(() => ({
        handleUser, handleLeaveRequest, handleClearRequest, btnLoader, fieldValues, setFieldValues, isRequestOpen, shiftEndDate
    }), [handleUser, handleLeaveRequest, handleClearRequest, btnLoader, fieldValues, setFieldValues, isRequestOpen, shiftEndDate])
}